import { render, staticRenderFns } from "./edit_profile.html?vue&type=template&id=c3745e10&scoped=true&"
import script from "./edit_profile.js?vue&type=script&lang=js&"
export * from "./edit_profile.js?vue&type=script&lang=js&"
import style0 from "./edit_profile.scss?vue&type=style&index=0&id=c3745e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3745e10",
  null
  
)

export default component.exports